import { render, staticRenderFns } from "./TelephoneTemplate.vue?vue&type=template&id=7d20d55b&scoped=true&"
import script from "./TelephoneTemplate.vue?vue&type=script&lang=js&"
export * from "./TelephoneTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d20d55b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d20d55b')) {
      api.createRecord('7d20d55b', component.options)
    } else {
      api.reload('7d20d55b', component.options)
    }
    module.hot.accept("./TelephoneTemplate.vue?vue&type=template&id=7d20d55b&scoped=true&", function () {
      api.rerender('7d20d55b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/TelephoneTemplate.vue"
export default component.exports